<template lang="pug">
    v-card(tile)
        v-card-title
            .subtitle-1.grey--text.font-weight-medium {{title}}
            .subtitle-1.grey--text.font-weight-light.font-italic &nbsp;(Draggable)
            v-spacer
            v-btn(dark color="primary" rounded @click="$emit('new')")
                v-icon(left) mdi-plus-circle
                span {{$t('general.new')}}
            v-btn(dark color="primary" rounded @click="$emit('delay')").ml-1
                v-icon(left) mdi-timer
                span {{$t('pages.settings.system.delay')}}
        v-card-title.pt-1
            v-divider
        v-card-text
            v-list(dense rounded)
                draggable(v-model='items' v-bind="{group:'people'}" style='min-height: 10px' @change="onListChanged")
                    template(v-for='item in items')
                        v-list-item(:key='item.id' @click="$emit('click', item)")
                            v-list-item-avatar(tile width="70").elevation-1
                                img(:src='item.url')
                            v-list-item-content
                                v-list-item-title(v-html='item.detail')
                                v-list-item-subtitle {{item.created_at | dateTimeFormat}}
                            v-list-item-action
                                v-row
                                    v-btn(icon @click.stop="$emit('delete', item)" :disabled="item.is_default")
                                        v-icon mdi-trash-can
                                    v-btn(icon @click.stop="$emit('toggle', item)").ml-1
                                        v-icon(:color="statusColor(item.published)") {{statusIcon(item.published)}}
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "BackgroundImageList",
  components: { draggable },
  props: {
    input: {
      required: true,
      type: Array
    },
    title: {
      type: String,
      default: "Background Images"
    }
  },
  model: {
    prop: "input",
    event: "update:input"
  },
  computed: {
    items: {
      get() {
        return this.input;
      },
      set(value) {
        this.$emit("update:input", value);
      }
    }
  },
  methods: {
    statusColor(published) {
      return published ? "green" : "red";
    },
    statusIcon(published) {
      return published
        ? "mdi-check-circle-outline"
        : "mdi-alert-circle-outline";
    },
    onListChanged(data) {
      this.$emit("change", data);
    }
  }
};
</script>

<style scoped></style>
